import { API_VERSION, BASE_URL } from '../constants/env.constant';

export const getEndpointBase = (endpoint: string) => {
  return `${BASE_URL}/api/${API_VERSION}/${endpoint}`;
};
